import { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns';
import {
  IOrderDeliveryTask,
  IPickupTask,
} from '../../../interfaces/delivery-company/tasks';
import { API_ENDPOINT } from '../../../configurations/global.config';
import axios from 'axios';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import {
  DeliveryBatchState,
  OrderDeliveryTaskState,
  PaymentTaskState,
  PickupTaskState,
} from '../../../enums/tasks';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  alpha,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import SnackBar from '../../common/snack-bar/snack-bar';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import { isMobile, isTablet } from 'react-device-detect';
import { ClearIcon } from '@mui/x-date-pickers';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CancelIcon from '@mui/icons-material/Cancel';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { showDeliveryTaskState } from '../../common/styles/delivery-task.styles';
import AddNotesDialog from '../common/add-notes-dialog';
import MarkAsFailedDialog from '../common/mark-as-failed-dialog';
import AddressWithIcon from '../../common/styles/address-with-icon';
import { displayMoney } from '../../../utils/money';
import { get_cod } from '../../../utils/cod';
import PaidIcon from '@mui/icons-material/Paid';
import { get_notes } from '../../../utils/notes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeliveryTaskPage from '../driver-delivery-tasks/delivery-task-page';
import Order from '../../delivery-company-components/order/order';
import { DeliveryState, Workflow } from '../../../enums/orders';
import { MerchantWithIcon } from '../../common/styles/merchant-with-icon';
import { IconWithText } from '../../common/styles/components';
import { blue, grey, red } from '@mui/material/colors';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { chipOpacity, chipPadding } from '../../common/styles/common';
import StaticGoogleMap from '../../common/static-google-map/static-google-map';
import { extractMapsPlaceLink } from '../../../utils/locations';
import DeliveryTaskQuickScanDialog from './delivery-task-dialog';
import PickupTaskQuickScanDialog from './pickup-task-dialog';

interface OrderDataCheckProps {
  id: string;
  onClose: () => void;
}
function OrderDataCheck({ id: packageId, onClose }: OrderDataCheckProps) {
  const [deliveryTask, setDeliveryTask] = useState<IOrderDeliveryTask>();
  const [pickupTask, setPickupTask] = useState<IPickupTask>();
  const [snackBar, setSnackBar] = useState<timestampedMessage>();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { user, config } = useContext(AuthContext);

  useEffect(() => {
    const fetchTask = async () => {
      let order: OrderType;
      setIsLoading(true);
      const orderId = packageId.slice(0, -4);
      try {
        const response = await axios.get<OrderType>(
          `${API_ENDPOINT}/api/v1/order/${orderId}/`,
          config
        );
        console.log(response.data);
        if (!response.data) {
          setMessage('No Order Found');
          throw new Error('No order found');
        }
        order = response.data;
        if (order.delivery_tasks && order.delivery_tasks.length > 0) {
          if (
            order.delivery_tasks[0].status !=
              OrderDeliveryTaskState.COMPLETED &&
            order.delivery_tasks[0].status != OrderDeliveryTaskState.FAILED
          ) {
            if (order.delivery_state !== DeliveryState.DELIVERY_ASSIGNED) {
              setDeliveryTask(order.delivery_tasks[0]);
            } else {
              setMessage('Please Scan the Batch Master Code to Proceed');
            }
          }
        }
        if (order.pickup_tasks && order.pickup_tasks.length > 0) {
          if (
            order.pickup_tasks[0].status != PickupTaskState.COMPLETED &&
            order.pickup_tasks[0].status != PickupTaskState.CANCELLED &&
            order.pickup_tasks[0].status != PickupTaskState.FAILED
          ) {
            console.log('is pickup task');
            setPickupTask(order.pickup_tasks[0]);
          }
        }

        if (deliveryTask && pickupTask) {
          setMessage('Please Contact ParcelTracer team for critical error');
        }
      } catch (e) {
        setSnackBar({
          timestamp: Date.now(),
          level: 'error',
          content: 'No order found',
        });
        setMessage('No Order Found');
        setIsLoading(false);
        return;
      }
      setIsLoading(false);
    };
    fetchTask();
  }, []);

  return (
    <>
      {isLoading ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CircularProgress />{' '}
        </div>
      ) : deliveryTask != undefined || pickupTask != undefined ? (
        <CustomDialog open={true} onClose={onClose} fullScreen={(isMobile && !isTablet)}>
          <DialogContent>
            {!!deliveryTask !== !!pickupTask ? (
              <>
                {deliveryTask && (
                  <DeliveryTaskQuickScanDialog
                    packageId={packageId}
                    onClose={onClose}
                  />
                )}

                {pickupTask && (
                  <PickupTaskQuickScanDialog
                    task={pickupTask}
                    onClose={onClose}
                  />
                )}
              </>
            ) : (
              <Alert severity="error">Fatal Error please contact support</Alert>
            )}
          </DialogContent>
        </CustomDialog>
      ) : (
        <Alert severity="error">{message}</Alert>
      )}
      {snackBar && snackBar.content && (
        <SnackBar
          message={snackBar.content}
          level={snackBar.level}
          key={snackBar.timestamp}
        />
      )}
    </>
  );
}

export default OrderDataCheck;
